export function isPrivacyPath(): boolean {
  return location.pathname === "/privacy" || location.pathname === "/privacy/";
}

export function privacyHtml(utcLabel: string): string {
  return `
    <div class="app-shell legal-shell">
      <header class="header glass">
        <a class="brand" href="/">
          <img class="brand-logo" src="/logo.jpg" alt="" />
          Meetingly
        </a>
        <div class="header-right">
          <div class="live-utc mono"><span class="pulse"></span>${utcLabel}</div>
          <a class="btn-ghost" href="/featurerequests">Feedback</a>
          <a class="btn-ghost" href="/"><span class="btn-label">Back to planner</span><span class="btn-short">Back</span></a>
        </div>
      </header>
      <article class="legal">
        <p class="legal-kicker mono">Privacy Policy</p>
        <h1>We don’t sell your data. We don’t share it with advertisers or data brokers.</h1>
        <p class="legal-meta">Effective 10 September 2026 · Meetingly is operated by Ahsan Ashraf at <a href="https://www.mymeetingly.com">mymeetingly.com</a>. Contact: <a href="mailto:A2ASHRAF@GMAIL.COM">A2ASHRAF@GMAIL.COM</a>.</p>

        <h2>What this product does</h2>
        <p>Meetingly helps people in different time zones pick a meeting time. You can use it without creating an account.</p>

        <h2>What we collect</h2>
        <ul>
          <li><strong>On your device only:</strong> the cities and time zones you add, the date and duration you pick, and (if you sign in with Google) a short-lived calendar token in your browser session. We do not need this to run the basic planner.</li>
          <li><strong>Scheduling rooms:</strong> if you click “Create a scheduling room,” we store the room’s time zones, optional display names, city names, map coordinates, busy/free intervals (not meeting titles), and the selected slot on Cloudflare Durable Objects. Rooms expire after 24 hours, or 2 hours after a time is chosen, then that room data is deleted.</li>
          <li><strong>Google Calendar (optional):</strong> only if you click Sign in with Google. We request the <code>calendar.freebusy</code> scope — whether you are busy, not event names, guests, or email contents. Busy intervals stay in your browser unless you are in a private room, in which case only those intervals are stored with the room.</li>
          <li><strong>.ics upload (optional):</strong> parsed in your browser. Recurring/timed events become busy intervals the same way.</li>
        </ul>

        <h2>What we do not do</h2>
        <ul>
          <li>We do not sell, rent, or trade personal information.</li>
          <li>We do not share personal information with third parties for their advertising, profiling, or marketing.</li>
          <li>We do not build advertising profiles or run third-party analytics pixels.</li>
          <li>We do not read Google Calendar event titles, attendees, or email.</li>
        </ul>

        <h2>Who else can see something</h2>
        <ul>
          <li><strong>People you invite:</strong> anyone with a private room link can see the time zones and greyed-out busy hours in that room. Treat the link like a meeting password.</li>
          <li><strong>Cloudflare:</strong> we host the site and rooms on Cloudflare. They process requests to run the service (hosting, TLS, security). We do not use Cloudflare to sell your data.</li>
          <li><strong>Google:</strong> only if you choose Sign in with Google, or because the site loads fonts from Google Fonts. Calendar access is opt-in. You can revoke it in your <a href="https://myaccount.google.com/permissions" target="_blank" rel="noreferrer">Google Account permissions</a>.</li>
        </ul>

        <h2>Cookies and local storage</h2>
        <p>We do not use advertising cookies. The planner may use <code>sessionStorage</code> / <code>localStorage</code> on your device for your member id, a Google token, and (if you pasted one during setup) a Google client id. You can clear these in your browser.</p>

        <h2>Retention</h2>
        <p>Private rooms are deleted automatically within 24 hours (sooner after a slot is picked). Browser storage lasts until you clear it or the tab session ends (for the Google token). We do not keep a marketing list.</p>

        <h2>Your choices</h2>
        <ul>
          <li>Use the planner without signing in or creating a room.</li>
          <li>Don’t sync a calendar — busy hours simply won’t grey out from Google.</li>
          <li>Leave a private room unused and it expires.</li>
          <li>Email <a href="mailto:A2ASHRAF@GMAIL.COM">A2ASHRAF@GMAIL.COM</a> to ask us to delete a room early if you still have the link.</li>
        </ul>

        <h2>Children</h2>
        <p>Meetingly is not directed at children under 13. We do not knowingly collect personal information from children.</p>

        <h2>Changes</h2>
        <p>If this policy changes, we will update this page and the effective date. Continued use after a change means you accept the updated policy.</p>

        <p class="legal-foot"><a href="/">← Back to Meetingly</a></p>
      </article>
    </div>
  `;
}
